export const ErrorText = 'error-text';
